import styled from 'styled-components';
import { globalTheme, } from '@clds/component-theme';
/**
 * Returns the actual value of the provided spacing constant from theme or 0 if not provided.
 * @param {string} propName name of the prop with spacing value to resolve
 */
const resolveSpacing = (propName) => (props) => {
    const spacing = props[propName];
    return spacing ? globalTheme.spacing[spacing](props) : '0rem';
};
const resolveHorizontalMargin = (props) => resolveSpacing('horizontalMargin')(props);
const resolveVerticalMargin = (props) => resolveSpacing('verticalMargin')(props);
export const HorizontalSeparator = styled.div.attrs((props) => ({
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    role: props.role || 'separator',
})) `
  height: 1px;
  width: calc(100% - 2 * ${resolveHorizontalMargin});
  margin: ${resolveVerticalMargin} ${resolveHorizontalMargin};
  background-color: ${globalTheme.palette.secondary};
`;
export const VerticalSeparator = styled.div.attrs((props) => ({
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    role: props.role || 'separator',
})) `
  width: 1px;
  height: calc(100% - 2 * ${resolveVerticalMargin});
  margin: ${resolveVerticalMargin} ${resolveHorizontalMargin};
  background-color: ${globalTheme.palette.secondary};
`;
//# sourceMappingURL=Separator.js.map